import React, { RefObject, createRef } from 'react';
import './ButtonsSpecial.scss';
import './ButtonsSpecial-media.scss';
import { HoverButton } from '../Button/Button';
import { LinkTg } from '../../services/content/Constants';
import {content} from "../../services/content";

const ButtonWhatsapp = ({ onClick }: any) => {
  const elLink: RefObject<HTMLDivElement> = createRef();
  const elSpan: RefObject<HTMLSpanElement> = createRef();

  return (
    <div
      className="button-whatsapp"
      onClick={onClick}
      ref={elLink}
      onMouseEnter={HoverButton(elLink, elSpan)}
      onMouseOut={HoverButton(elLink, elSpan)}
    >
      {content.buttonsSpecial.getInWhatsapp}
      <span ref={elSpan}></span>
    </div>
  );
};

const ButtonTelegram = () => {
  const elLink: RefObject<HTMLAnchorElement> = createRef();
  const elSpan: RefObject<HTMLSpanElement> = createRef();

  return (
    <a
      href={LinkTg}
      target="_blank"
      className="button-telegram"
      ref={elLink}
      onMouseEnter={HoverButton(elLink, elSpan)}
      onMouseOut={HoverButton(elLink, elSpan)}
      rel="nofollow"
    >
      {content.buttonsSpecial.getInTelegram}
      <span ref={elSpan}></span>
    </a>
  );
};

const ButtonOborot = ({ widthWindow }: { widthWindow: number }) => {
  return (
    <div className="button-oborot">
      <a
        href="https://oborot.ru/forum/dalli-service-kto-s-nimi-rabotaet-i33972.html"
        target="_blank"
        className="button-oborot__link"
        rel="nofollow"
      >
        {widthWindow > 720 ? content.buttonsSpecial.feedbackOborot : content.buttonsSpecial.feedbackOborotShort}
      </a>

      <div className="button-oborot__bg" />
    </div>
  );
};

export { ButtonWhatsapp, ButtonTelegram, ButtonOborot };
